// Fetch messages
export const FETCH_MESSAGES_REQUEST = 'FETCH_MESSAGES_REQUEST';
export const FETCH_MESSAGES_SUCCESS = 'FETCH_MESSAGES_SUCCESS';
export const FETCH_MESSAGES_FAILURE = 'FETCH_MESSAGES_FAILURE';

// Unread count
export const FETCH_UNREAD_COUNT_REQUEST = 'FETCH_UNREAD_COUNT_REQUEST';
export const FETCH_UNREAD_COUNT_SUCCESS = 'FETCH_UNREAD_COUNT_SUCCESS';

// Mark read
export const MARK_MESSAGE_READ_REQUEST = 'MARK_MESSAGE_READ_REQUEST';
export const MARK_MESSAGE_READ_SUCCESS = 'MARK_MESSAGE_READ_SUCCESS';

// Mark all read
export const MARK_ALL_READ_REQUEST = 'MARK_ALL_READ_REQUEST';
export const MARK_ALL_READ_SUCCESS = 'MARK_ALL_READ_SUCCESS';

// Notification Poller
export const START_NOTIFICATION_POLLER = 'START_NOTIFICATION_POLLER';
export const STOP_NOTIFICATION_POLLER = 'STOP_NOTIFICATION_POLLER';

// Action creators
export const fetchMessagesRequest = () => ({
  type: FETCH_MESSAGES_REQUEST
});

export const fetchUnreadCountRequest = () => ({
  type: FETCH_UNREAD_COUNT_REQUEST
});

export const markMessageReadRequest = (messageId) => ({
  type: MARK_MESSAGE_READ_REQUEST,
  payload: { messageId }
});

export const markAllReadRequest = () => ({
  type: MARK_ALL_READ_REQUEST
});

/**
 * Inicia el polling automático de notificaciones
 * @param {number} interval - Intervalo en milisegundos (opcional, por defecto 2 minutos)
 */
export const startNotificationPoller = (interval = null) => ({
  type: START_NOTIFICATION_POLLER,
  payload: { interval }
});

/**
 * Detiene el polling automático de notificaciones
 */
export const stopNotificationPoller = () => ({
  type: STOP_NOTIFICATION_POLLER
});
